'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CheckmarkThickIcon = undefined;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

var CheckmarkThickIcon = function CheckmarkThickIcon(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === undefined ? 'black' : _ref$color,
      _ref$height = _ref.height,
      height = _ref$height === undefined ? 24 : _ref$height,
      _ref$width = _ref.width,
      width = _ref$width === undefined ? 24 : _ref$width,
      props = _objectWithoutProperties(_ref, ['color', 'height', 'width']);

  return _react2.default.createElement('svg', _extends({
    width: width,
    height: height,
    viewBox: '0 0 24 24'
  }, props), _react2.default.createElement('path', {
    fill: color,
    d: 'M8.116 18.384L3.13 13.396a1.25 1.25 0 1 1 1.755-1.78L9 15.733 19.13 5.604a1.25 1.25 0 0 1 1.735.03c.476.477.49 1.244.019 1.75L9.886 18.38a1.24 1.24 0 0 1-.886.37c-.333 0-.652-.132-.884-.366z'
  }));
};

exports.CheckmarkThickIcon = CheckmarkThickIcon;